export default __webpack_public_path__ + "static/media/multi.7762aeb6.png";